<template>
  <div class="cases">
    <el-button type="primary" @click="openDialog()">新增数据</el-button>

    <el-table border :data="tableData" v-loading="loading" style="width: 100%">
      <el-table-column prop="id" label="序号" width="180"></el-table-column>
      <el-table-column prop="img" label="企业Logo">
        <template slot-scope="scope">
          <img style="width:200px" :src="imgserver+scope.row.img" alt />
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="企业名称" width="180"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        layout="sizes, prev, pager, next"
        :page-sizes="[5, 10, 15, 20]"
        :total="total"
        :current-page="page"
        :page-size="size"
        @current-change="currentChange"
        @size-change="sizeChange"
    ></el-pagination>
    <el-dialog title="合作企业管理" :visible.sync="dialogFormVisible">
      <el-form :model="formData">
        <el-form-item label="企业Logo" :label-width="formLabelWidth">
          <el-upload
            class="avatar-uploader"
            :action="uploadserver"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleSuccess"
          >
            <img v-if="formData.img" :src="imgserver+formData.img" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="企业名称" :label-width="formLabelWidth">
          <el-input v-model="formData.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCreateOrModify()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      page: 1,
      size: 10,
      tableData: [],
      total: 0,
      formData: {
        id: 0,
        img: "",
        remark: "",
        time: new Date()
      },
      options: {},
      headers: {}
    };
  },
  mounted() {
    let token = "Bearer " + sessionStorage.getItem("token");
    this.options = { headers: { Authorization: token }};
    this.headers = { Authorization: token };
    this.loadData();
  },
  methods: {
    handleSuccess(response, file, fileList) {
      window.console.log(response, file, fileList);
      this.formData.img = response;
    },
    loadData() {
      this.loading = true;
      this.$http.get(`enterprise/list?page=${this.page}&size=${this.size}`, this.options).then(response => {
          this.tableData = response.data.list;
          this.loading = false;
        }).catch(e => {
          this.$message({
            message: e.message,
            type: "error"
          })
        })
    },
    openDialog() {
      this.formData.id = 0
      this.formData.img = ""
      this.formData.remark = ""
      this.formData.time = new Date()
      this.dialogFormVisible = true
    },
    handleCreateOrModify() {
      this.loading = true;
      this.$http.post("enterprise/edit", this.formData, this.options).then(() => {
        this.loading = false;
        this.$message({
          message: "创建成功！",
          type: "success"
        })
        this.dialogFormVisible = false
        this.loadData()
      }).catch(e => {
        this.$message({
          message: e.message,
          type: "error"
        })
      })
    },
    handleEdit(index, row) {
      this.formData = row;
      this.dialogFormVisible = true;
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          this.loading = true;
          this.$http.post(
              `enterprise/delete?id=${row.id}`,
              null,
              this.options
          ).then(() => {
              this.loading = false;
              this.$message({
                message: "删除成功！",
                type: "success"
              });
              this.loadData();
            }).catch(e => {
              this.$message({
                message: e.message,
                type: "error"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    currentChange(val) {
      this.page = val;
      this.loadData();
    },
    sizeChange(val) {
      this.size = val;
      this.loadData();
    },
    dateFormat: function(row) {
      let t = new Date(row.time);
      return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate();
    }
  }
};
</script>

<style scoped>
.el-table {
  margin-top: 20px;
}
</style>